const isRTL = () => {
	return document.documentElement.dir === 'rtl';
};

export default isRTL;
